import request from '../request';
import requestUrl from '../requestUrl';
import requestParam from '../requestParam';

/**
 * 查询 general
 * @param {*} s
 */
export const queryGeneral = params => {
    return request({
        url: requestUrl('/client/site/general'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * 保存 general
 * @param {*} s
 */
export const saveGeneral = params => {
    return request({
        url: requestUrl('/site/general/save'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * 检查EntityName 是否已经存在
 * @param {*} s
 */
export const checkNameExist = params => {
    return request({
        url: requestUrl('/clientEntity/checkNameExist'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * 检查s节点是否关联业务数据
 * @param {*} s
 */
export const checkAssociated = params => {
    return request({
        url: requestUrl('/clientEntity/checkAssociated'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * import Entity => import
 * @param {*} s
 */
export const uploadEntityFile = params => {
    return request({
        url: requestUrl('/clientEntity/import'),
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};

/**
 * import Entity => download
 * @param {*} s
 */
export const downloadEntityTemplate = params => {
    return request({
        url: requestUrl('/clientEntity/downloadEntityTemplate'),
        method: 'get',
        data: requestParam(params),
        responseType: 'blob'
    });
};

/**
 * sendNotificationEmail
 * @param {*} s
 */
export const insightUploadFile = params => {
    return request({
        url: requestUrl('/insight/uploadFile'),
        method: 'post',
        data: params,
        timeout: 900000,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};


/**
 * 检查s节点是否关联业务数据
 * @param {*} s
 */
export const checkTileBind = params => {
    return request({
        url: requestUrl('/site/general/checkTileBind'),
        method: 'post',
        data: requestParam(params)
    });
};


/**
 * TO NEXT YEAR查询pbc信息
 * @param {*} s
 */
export const queryPbcByEntity = params => {
    return request({
        url: requestUrl('/rollForward/queryPbcByEntity'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * TO NEXT YEAR查询MatterLog信息
 * @param {*} s
 */
export const queryMatterLogByEntity = params => {
    return request({
        url: requestUrl('/rollForward/queryMatterLogByEntity'),
        method: 'post',
        data: requestParam(params)
    });
};


/**
 * TO NEXT YEAR提交
 * @param {*} s
 */
export const saveRemainInfo = params => {
    return request({
        url: requestUrl('/rollForward/saveRemainInfo'),
        method: 'post',
        data: requestParam(params)
    });
};

export const siteInfo = params => {
    return request({
        url: requestUrl('/client/site/siteInfo'),
        method: 'post',
        data: requestParam(params)
    })
}

export const getMilestoneSetting = params => {
    return request({
        url: requestUrl('/sys/clientStatAccState/getMilestoneSetting'),
        method: 'post',
        data: requestParam(params)
    })
}
export const saveMilestoneSetting = params => {
    return request({
        url: requestUrl('/sys/clientStatAccState/saveSetting'),
        method: 'post',
        data: requestParam(params)
    })
}

export const siteTilesGeneral = params => {
    return request({
        url: requestUrl('/client/site/tiles/general'),
        method: 'post',
        data: requestParam(params)
    })
}

export const organizationGeneral = params => {
    return request({
        url: requestUrl('/client/site/organization/general'),
        method: 'post',
        data: requestParam(params)
    })
}

export const saveOrganization = params => {
    return request({
        url: requestUrl('/site/organization/save'),
        method: 'post',
        data: requestParam(params)
    })
}

export const saveTiles = params => {
    return request({
        url: requestUrl('/site/tiles/save'),
        method: 'post',
        data: requestParam(params)
    })
}
export const getClientTile = params => {
    return request({
        url: requestUrl('/client/user/getClientTile'),
        method: 'post',
        data: requestParam(params)
    })
}


